import ScraperDashboard from '../components/ScraperDashboard'

export default function Dashboard() {
  return (
    <ScraperDashboard
      source="bitcoin_live"
      scrapeEndpoint="/scrape"
      pageTitle="System Monitoring"
      pageDescription="Real-time status of Bitcoin.Live premium scraper pipeline."
      triggerLabel="Trigger Manual Scrape"
      postsLinkPath="/posts"
      itemNounSingular="Article"
      itemNounPlural="Posts"
    />
  )
}
